// extracted by mini-css-extract-plugin
export default {"wrapper":"jCdBk9tlSuwecIoyMVdZ","right-margin":"YbTpimIlmKzQCvCS0ssi","left-panel":"sJEHluP0yfhBIpzuXjRw","container":"fPNgy8_YszeHLH8VCDR6"};